// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  baseUrl: 'https://pagos-backend.services.geducar.com',
  firebase: {
    apiKey: 'AIzaSyAieB2zdUwHbxlcej1CCYl7nwF_Y071rS0',
    authDomain: 'geducar-fca41.firebaseapp.com',
    databaseURL: 'https://geducar-fca41.firebaseio.com',
    projectId: 'geducar-fca41',
    storageBucket: 'geducar-fca41.appspot.com',
    messagingSenderId: '228759204356',
    appId: '1:228759204356:web:18d735120a51f8ed73fb51'
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/dist/zone-error';  // Included with Angular CLI.
